export enum ApiHttpError {
    TokenExpiredError = 'TokenExpiredError',
    ForceLogoutError = 'ForceLogoutError',
}
